import type { ColumnDef } from "@tanstack/react-table";
import type { ApReceipt } from "@/accounts-payable/types";
import { formatCentsOrDashIfZero } from "@/core/utils/money";

export const totalCol: ColumnDef<ApReceipt> = {
  accessorKey: "total_amount_cents",
  header: "Total",
  meta: { size: "110px", align: "right" },
  cell: ({ row }) => (
    <span className="font-semibold tabular-nums">
      {formatCentsOrDashIfZero(row.original.total_amount_cents)}
    </span>
  ),
};
